import React, { useState } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { UserWorkingHours } from '../../../../api/types/lecturers/working-hours/user-working-hours';
import dateUtils from '../../../../utils/date-format';
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { FaChevronDown } from 'react-icons/fa';
import { updateWorkingHoursHoeScreenOperation } from './operations/update-working-hours-hoe-screen-operation';
import { WorkingHoursStatus } from '../../../../api/types/lecturers/working-hours/working-hours.type';

interface MissingReportedHoursHomePageProps {
  pendingWorkingHours: UserWorkingHours[];
  onUpdate: () => any;
}

const MissingReportedHoursHomePage: React.FC<
  MissingReportedHoursHomePageProps
> = ({ pendingWorkingHours, onUpdate }) => {
  const [selectedWorkingHour, setSelectedWorkingHour] =
    useState<UserWorkingHours | null>(null);
  const [showDetailsDialog, setShowDetailsDialog] = useState(false);
  const [expandedItems, setExpandedItems] = useState(false);

  // Filter working hours to show only pending ones
  const pendingItems = pendingWorkingHours.filter(
    (item) => item.status === 'pendingForApproval',
  );

  const getStatusTag = (status: string) => {
    switch (status) {
      case 'pendingForApproval':
        return <Tag severity="warning" value="ממתין לאישור" />;
      case 'approved':
        return <Tag severity="success" value="אושר" />;
      case 'denied':
        return <Tag severity="danger" value="נדחה" />;
      default:
        return <Tag severity="info" value={status} />;
    }
  };

  const handleViewDetails = (item: UserWorkingHours) => {
    setSelectedWorkingHour(item);
    setShowDetailsDialog(true);
  };

  const onHideDialog = () => {
    setShowDetailsDialog(false);
    setSelectedWorkingHour(null);
    setExpandedItems(false);
  };

  const notifyUpdate = () => {
    onHideDialog();
    onUpdate();
  };

  const handleApprove = async (item: UserWorkingHours) => {
    await updateWorkingHoursHoeScreenOperation(
      item.id,
      WorkingHoursStatus.Approved,
      notifyUpdate,
    );
  };

  const handleReject = async (item: UserWorkingHours) => {
    await updateWorkingHoursHoeScreenOperation(
      item.id,
      WorkingHoursStatus.Reject,
      notifyUpdate,
    );
  };

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        padding: '20px',
        height: '100%',
        borderRadius: '12px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: '5px',
        }}
      >
        <div
          style={{ paddingBottom: '10px', color: '#185FD3', fontSize: '18px' }}
        >
          שעות דיווח חסרות ({pendingItems.length})
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button
            icon="pi pi-eye"
            label="הרחב תצוגה"
            severity="secondary"
            outlined
            size="small"
            onClick={() => {
              setExpandedItems(true);
              setShowDetailsDialog(true);
            }}
          />
          {/*<ExportButton
            onClick={() => {
              // TODO
            }}
          />*/}
        </div>
      </div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        value={pendingItems}
        scrollHeight="200px"
        scrollable
        onRowClick={(e) => handleViewDetails(e.data as UserWorkingHours)}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
        rowHover
        style={{ cursor: 'pointer' }}
      >
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="branchName"
          header="שלוחה"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UserWorkingHours) => (
            <div>{rowData.branchName || 'לא צוין'}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="createdByName"
          header="שם"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UserWorkingHours) => (
            <div>{rowData.createdByName}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="startAt"
          header="תאריך"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UserWorkingHours) => (
            <div>{dateUtils.displayFormatDate(rowData.startAt)}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="timeRange"
          header="שעת התחלה וסיום"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UserWorkingHours) => (
            <div style={{ direction: 'ltr', textAlign: 'right' }}>
              {dateUtils.formatTimeRangeBetweenDates(
                rowData.startAt,
                rowData.endAt,
              )}
            </div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="actions"
          header=""
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UserWorkingHours) => (
            <div
              style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}
            >
              <Button
                icon="pi pi-times"
                severity="warning"
                text
                size="small"
                tooltip="ביטול"
                tooltipOptions={{ position: 'top' }}
                style={{ height: '24px', width: '24px' }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleReject(rowData);
                }}
              />
              <Button
                icon="pi pi-check"
                severity="success"
                text
                size="small"
                tooltip="אישור"
                tooltipOptions={{ position: 'top' }}
                style={{ height: '24px', width: '24px' }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleApprove(rowData);
                }}
              />
            </div>
          )}
        />
      </DataTable>

      {/* Details Dialog */}
      <Dialog
        header={
          expandedItems ? 'שעות דיווח חסרות - תצוגה מורחבת' : `פרטי שעות עבודה`
        }
        visible={showDetailsDialog}
        onHide={() => onHideDialog()}
        style={{
          width: expandedItems ? '90vw' : '80vw',
          maxWidth: expandedItems ? '1200px' : '800px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
        maximizable
      >
        {expandedItems ? (
          // Expanded view showing all pending items
          <div style={{ width: '100%' }}>
            <DataTable
              value={pendingItems}
              scrollable
              scrollHeight="60vh"
              dataKey="id"
              tableStyle={{ direction: 'rtl' }}
              emptyMessage={
                <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
              }
            >
              <Column
                field="branchName"
                header="שלוחה"
                style={{ textAlign: 'right' }}
                body={(rowData: UserWorkingHours) => (
                  <div>{rowData.branchName || 'לא צוין'}</div>
                )}
              />
              <Column
                field="programName"
                header="תוכנית"
                style={{ textAlign: 'right' }}
                body={(rowData: UserWorkingHours) => (
                  <div>{rowData.programName || 'לא צוין'}</div>
                )}
              />
              <Column
                field="courseName"
                header="קורס"
                style={{ textAlign: 'right' }}
                body={(rowData: UserWorkingHours) => (
                  <div>{rowData.courseName || 'לא צוין'}</div>
                )}
              />
              <Column
                field="createdByName"
                header="נוצר על ידי"
                style={{ textAlign: 'right' }}
              />
              <Column
                field="timeRange"
                header="שעות"
                style={{ textAlign: 'right' }}
                body={(rowData: UserWorkingHours) => (
                  <div style={{ direction: 'ltr', width: '120px' }}>
                    {dateUtils.formatTimeRangeBetweenDates(
                      rowData.startAt,
                      rowData.endAt,
                    )}
                  </div>
                )}
              />
              <Column
                field="duration"
                header="משך"
                style={{ textAlign: 'right', width: '120px' }}
                body={(rowData: UserWorkingHours) => (
                  <div>
                    {dateUtils.calculateHoursDifference(
                      rowData.startAt,
                      rowData.endAt,
                    )}{' '}
                    שעות
                  </div>
                )}
              />
              <Column
                field="rate"
                header="תעריף"
                style={{ textAlign: 'right' }}
                body={(rowData: UserWorkingHours) => <div>₪{rowData.rate}</div>}
              />
              <Column
                field="status"
                header="סטטוס"
                style={{ textAlign: 'right', width: '120px' }}
                body={(rowData: UserWorkingHours) => (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {getStatusTag(rowData.status)}
                  </div>
                )}
              />
              <Column
                field="actions"
                header="פעולות"
                style={{ textAlign: 'right' }}
                body={(rowData: UserWorkingHours) => (
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      justifyContent: 'center',
                    }}
                  >
                    <Button
                      label="ביטול"
                      icon="pi pi-times"
                      severity="warning"
                      outlined
                      size="small"
                      style={{ minWidth: '80px' }}
                      onClick={() => handleReject(rowData)}
                    />
                    <Button
                      label="אישור"
                      icon="pi pi-check"
                      severity="success"
                      size="small"
                      style={{ minWidth: '80px' }}
                      onClick={() => handleApprove(rowData)}
                    />
                  </div>
                )}
              />
            </DataTable>
          </div>
        ) : selectedWorkingHour ? (
          // Individual item details
          <div style={{ direction: 'rtl' }}>
            <Accordion
              style={{ direction: 'ltr', width: '100%' }}
              expandIcon={(options) => (
                <FaChevronDown
                  style={{
                    transform: options.isActive
                      ? 'rotate(0deg)'
                      : 'rotate(90deg)',
                    transition: 'transform 0.3s',
                    marginLeft: '8px',
                  }}
                />
              )}
              collapseIcon={(options) => (
                <FaChevronDown
                  style={{
                    transform: options.isActive
                      ? 'rotate(90deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.3s',
                    marginLeft: '8px',
                  }}
                />
              )}
            >
              <AccordionTab
                headerStyle={{ direction: 'rtl' }}
                style={{ direction: 'rtl' }}
                header="פרטי שעות העבודה"
              >
                <div style={{ padding: '16px' }}>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>תאריך:</strong>{' '}
                    {dateUtils.displayFormatDate(selectedWorkingHour.startAt)}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>שעות:</strong>{' '}
                    {dateUtils.formatTimeRangeBetweenDates(
                      selectedWorkingHour.startAt,
                      selectedWorkingHour.endAt,
                    )}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>משך:</strong>{' '}
                    {dateUtils.calculateHoursDifference(
                      selectedWorkingHour.startAt,
                      selectedWorkingHour.endAt,
                    )}{' '}
                    שעות
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>שלוחה:</strong>{' '}
                    {selectedWorkingHour.branchName || 'לא צוין'}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>תוכנית:</strong>{' '}
                    {selectedWorkingHour.programName || 'לא צוין'}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>קורס:</strong>{' '}
                    {selectedWorkingHour.courseName || 'לא צוין'}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>תעריף:</strong> ₪{selectedWorkingHour.rate}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>סה"כ לתשלום:</strong> ₪
                    {dateUtils.calculateHoursDifference(
                      selectedWorkingHour.startAt,
                      selectedWorkingHour.endAt,
                    ) * selectedWorkingHour.rate}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>סוג:</strong>{' '}
                    {selectedWorkingHour.isManual ? 'שעה ידנית' : 'אוטומטית'}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>נוצר על ידי:</strong>{' '}
                    {selectedWorkingHour.createdByName}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>נוצר ב:</strong>{' '}
                    {dateUtils.displayFormatDate(selectedWorkingHour.createdAt)}
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <strong>סטטוס:</strong>{' '}
                    {getStatusTag(selectedWorkingHour.status)}
                  </div>

                  <div
                    style={{ display: 'flex', gap: '12px', marginTop: '20px' }}
                  >
                    <Button
                      label="ביטול הזמן"
                      severity="warning"
                      outlined
                      onClick={() => handleReject(selectedWorkingHour)}
                    />
                    <Button
                      label="אישור הזמן"
                      severity="success"
                      onClick={() => handleApprove(selectedWorkingHour)}
                    />
                  </div>
                </div>
              </AccordionTab>
            </Accordion>
          </div>
        ) : null}
      </Dialog>
    </div>
  );
};

export default MissingReportedHoursHomePage;
